
import { Component, Vue, Prop} from 'vue-property-decorator';

import Form1ProcessHeader from "@/components/process/Form1/components/Form1ProcessHeader.vue";
import { packageInfoType } from '@/types/Information';
import { form1DataInfoType, form1StatusInfoType } from '@/types/Information/Form1';

@Component({
    components:{
        Form1ProcessHeader
    }
})
export default class SuccessSubmitForm1 extends Vue {

    @Prop({required: true})
    packageInfo!: packageInfoType;

    stepsCompleted = {} as form1StatusInfoType;  
    mountedData = false; 

    form1Data = {} as form1DataInfoType;

    mounted() {
        this.mountedData = false;
        this.stepsCompleted = {
            first: true,
            second: true,
            third: true
        } 
        this.saveApplication(this.packageInfo);               
    }

    public saveApplication(newPackageInfo: packageInfoType) {

        const data = {
            packageNumber: newPackageInfo.packageNumber,
            packageUrl: newPackageInfo.eFilingUrl 
        } 

        const url = "/form1/efiling/"+newPackageInfo.fileNumber+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        this.$http.put(url, data, header)
        .then(res => {                            
            this.getForm1Data(newPackageInfo.fileNumber);
        }, err => {
            console.error(err);
            this.mountedData = true;
        });    
    }    

    public getForm1Data(fileNumber) {        
       
        this.$http.get('/form1/forms/'+fileNumber)
        .then((response) => {
            if(response?.data?.data){            
                            
                this.form1Data = response.data.data
                console.log(this.form1Data)
                
                this.mountedData = true;
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
